// E-Mail-OTP-Login (V1.14): alternativer Anmeldeweg neben Entra/MSAL.
// Das vom Backend ausgegebene Session-Token (vts_…) wird in localStorage
// gehalten und vom tokenInterceptor als Fallback-Bearer verwendet, wenn kein
// MSAL-Account vorliegt.
const TOKEN_KEY = 'vitals_otp_token'

export function getOtpToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function hasOtpToken(): boolean {
  return !!getOtpToken()
}

function setOtpToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch {
    /* localStorage kann blockiert sein — Token bleibt dann nur im Speicher des Tabs. */
  }
}

export function clearOtpToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

// Schritt 1: Code anfordern. Das Backend antwortet aus Anti-Enumeration-Gründen
// IMMER mit 200 — auch bei unbekannter E-Mail. Wir werfen daher nicht.
export async function requestOtp(email: string): Promise<void> {
  await fetch('/api/auth/otp/request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })
}

export interface VerifyResult {
  token: string
  expiresAt: string
}

// Schritt 2: Code prüfen. 200 ⇒ Token speichern + zurückgeben; 400 ⇒ Fehler.
export async function verifyOtp(email: string, code: string): Promise<VerifyResult> {
  const res = await fetch('/api/auth/otp/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  })
  if (!res.ok) {
    throw new Error('otp_invalid')
  }
  const data = (await res.json()) as VerifyResult
  setOtpToken(data.token)
  return data
}

// Backend-Session revozieren und Token lokal löschen. Fehler werden toleriert —
// lokal abmelden muss auch ohne Netz funktionieren.
export async function otpLogout(): Promise<void> {
  const token = getOtpToken()
  if (token) {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      })
    } catch {
      /* Revoke best-effort. */
    }
  }
  clearOtpToken()
}
